<ng-container
  *ngIf="
    right?.searchPane?.searchableObservable$ | async as searchableNonUsfProducts
  "
>
  <div
    class="flex-container"
    *ngIf="(right?.error | async) === false; else noData"
  >
    <ion-label
      [attr.data-cy]="dataCyTag + '-seaarch-title'"
      *ngIf="!!right?.searchPane?.searchTitle"
      class="subtitle search-title"
    >
      {{ right?.searchPane?.searchTitle | translate }}
    </ion-label>
    <ion-searchbar
      [attr.data-cy]="dataCyTag + '-search-bar'"
      class="search"
      mode="md"
      placeholder="{{ right?.searchPane?.searchPlaceholder | translate }}"
      [(ngModel)]="right.searchPane.searchKey"
      (ionClear)="resetSearch()"
      (ionInput)="handleSearch()"
    ></ion-searchbar>

    <div
      data-cy="no-results-found"
      class="no-results-found"
      *ngIf="searchableNonUsfProducts?.length === 0"
    >
      {{
        right?.searchPane?.noResultsOverride ??
          'i18n.lists.copyListModal.noResultsFound' | translate
      }}
    </div>
    <ion-list>
      <ion-radio-group value="{{ right?.selectedItem }}">
        <div
          class="select-all-container"
          *ngIf="!right?.countPane?.hideSelectAll"
        >
          <ion-item
            *ngIf="searchableNonUsfProducts?.length > 0"
            class="checkbox-item select-all"
            lines="none"
          >
            <ion-checkbox
              justify="end"
              [checked]="
                left?.content[0]?.value?.length ===
                searchableNonUsfProducts?.length
              "
              (ionChange)="handleSelectAll($event, searchableNonUsfProducts)"
              mode="ios"
            >
              {{
                left?.content[0]?.value?.length ===
                searchableNonUsfProducts?.length
                  ? ('i18n.lists.copyListModal.deselectAll' | translate)
                  : ('i18n.lists.copyListModal.selectAll' | translate)
              }}
            </ion-checkbox>
          </ion-item>
        </div>
        <app-multi-select-non-usf-button
          *ngFor="let nonUsf of searchableNonUsfProducts; let i = index"
          [nonUsfProduct]="nonUsf"
          [index]="i"
          (selectNonUsfProductEmitter)="nonUsfSelected($event)"
        >
        </app-multi-select-non-usf-button>
      </ion-radio-group>
    </ion-list>
  </div>
</ng-container>

<ng-template #noData>
  <div>
    <p class="subtitle-medium">
      OH NOOOOO
      {{ right?.errorMessage ?? '' | translate }}
    </p>
  </div>
</ng-template>
